module.exports = __webpack_public_path__ + "static/img/icon_drawer.f9f5ce72.png";